import CommunitiesDetails from './CommunitiesDetails';

export default CommunitiesDetails;
